import React from 'react';

interface SearchBarProps {
  searchTerm: string;
  handleSearch: (value: string) => void;
  placeholderText?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({ searchTerm, handleSearch, placeholderText }) => {
  return (
    <div className="relative flex-grow sm:flex-grow-0 flex">
      <form className="relative w-full">
        <input
          type="text"
          placeholder={placeholderText ? placeholderText : "Search by Name, Type and Status"}
          className="w-full sm:w-80 pl-10 pr-9 py-2 border border-border rounded-l-input text-body focus:outline-none"
          value={searchTerm}
          onChange={(e) => handleSearch(e.target.value)}
        />
        <svg className="w-5 h-5 text-text-secondary absolute left-3 top-2.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
        {searchTerm && (
          <button
            id="btn-clear-search"
            className="absolute right-3 top-3 text-text-secondary hover:text-text-primary"
            onClick={() => handleSearch('')}
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
      </form>
    </div>
  );
};

export default SearchBar;
